import React from 'react'

import { useClaimReferralModal } from '@/components/misc/ReferralDetails/hooks/useClaimReferralModal'
import { cn } from '@/lib/utils'

type Props = Omit<React.HTMLAttributes<HTMLSpanElement>, 'onClick'> & {
  children: React.ReactNode
}

const ClaimAccountButton: React.FC<Props> = ({
  children,
  className,
  ...props
}) => {
  const claimReferralModal = useClaimReferralModal()

  return (
    <span
      onClick={() => {
        claimReferralModal.show()
      }}
      className={cn('cursor-pointer', className)}
      {...props}
    >
      {children}
    </span>
  )
}

export default ClaimAccountButton
